module.exports = __webpack_public_path__ + "img/img9.280f6078.png";